export default "__VITE_ASSET__7b7f2e22__"